import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Loader = () => {

    return (
        <React.Fragment>
            <Container>
                <Row className="justify-content-center page-content">
                    <Col xl={7} lg={8}>
                        <div className="custom-loader-container">
                            <div className="custom-loader"></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default Loader;
